import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyPound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.05 18.465a6 6 0 0 1-5 0 6 6 0 0 0-5 .5 3 3 0 0 0 2-2.5v-7.5a4 4 0 0 1 7.45-2m-2.55 6h-7"
    />
  </svg>
);
export default SvgCurrencyPound;
